import React from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';

interface AnswerCommentSheetProps {
    open: boolean;
    onDismiss: () => void;
    answer: string;
    comment: string;
}

function AnswerCommentSheet({open, onDismiss, answer, comment}: AnswerCommentSheetProps): JSX.Element {
    return (
        <BottomSheet
            snapPoints={({minHeight, maxHeight}) => [Math.max(minHeight, maxHeight * 0.4), maxHeight * 0.75, maxHeight]}
            defaultSnap={({minHeight, maxHeight}) => Math.max(minHeight, maxHeight * 0.4)}
            open={open}
            onDismiss={onDismiss}
            header={<div className="c-answerCommentSheet__header">{answer}</div>}
        >
            <div className="c-answerCommentSheet__content">{comment}</div>
        </BottomSheet>
    );
}

export default AnswerCommentSheet;
